// "Start my daily briefing": the reader's morning report on the quality
// signals, as a watch (kanban 001b6e2b folded the personal digest into
// watches). Shown on the Briefing page while the reader has no briefing; an
// optional line of focus becomes part of the subject, in their words.
import { useState } from 'react';
import styles from './watches.module.css';

export const BRIEFING_SUBJECT =
  'My daily briefing: what changed in the quality signals that matters to me';

export interface BriefingStartProps {
  busy: boolean;
  onStart: (subject: string) => Promise<unknown>;
}

/** The subject the briefing watch is created with. */
export function briefingSubject(focus: string): string {
  const extra = focus.trim();
  return extra ? `${BRIEFING_SUBJECT}. Focus on: ${extra}` : BRIEFING_SUBJECT;
}

export function BriefingStart({ busy, onStart }: BriefingStartProps) {
  const [focus, setFocus] = useState('');

  return (
    <div className={styles.newForm} data-testid="briefing-start">
      <h2>Start my daily briefing</h2>
      <p className={styles.hint}>
        Every working morning Merlin reads the quality signals and writes you a short briefing:
        what changed, what needs you, what is getting better. It is a watch like any other: change
        the cadence, pause it, or tell Merlin in the chat what to add or drop.
      </p>
      <label className={styles.label} htmlFor="briefing-focus">
        Anything it should focus on? (optional)
      </label>
      <textarea
        id="briefing-focus"
        className={styles.textarea}
        value={focus}
        onChange={(e) => setFocus(e.target.value)}
        placeholder="e.g. Start from the customers in limbo and drill down to the orders behind them."
        maxLength={1500}
        rows={3}
      />
      <div className={styles.formRow}>
        <button
          type="button"
          className={styles.primaryBtn}
          onClick={() => void onStart(briefingSubject(focus))}
          disabled={busy}
          data-action="briefing_start"
          data-outcome="request"
        >
          {busy ? 'Starting…' : 'Start my daily briefing'}
        </button>
      </div>
    </div>
  );
}
